import { render, staticRenderFns } from "./ReplyTopPanel.vue?vue&type=template&id=0fe4b7f4&scoped=true&"
import script from "./ReplyTopPanel.vue?vue&type=script&lang=js&"
export * from "./ReplyTopPanel.vue?vue&type=script&lang=js&"
import style0 from "./ReplyTopPanel.vue?vue&type=style&index=0&id=0fe4b7f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe4b7f4",
  null
  
)

export default component.exports